//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GenericMeasure.js";
import "../no/MeasureManager.js";
import "../no/ugmath.js";
let d=[[[0,"Area",0,0],[0,"Centroid",0,0],[0,"InformationUnit",1,0],[0,"Mass",0,0],[0,"RadiusOfGyration",0,0],[0,"Volume",0,0],[0,"Weight",0,0]],[[[],"CreateFeature",{R_:{feature:"Measure"}},0,0],[["measurement_type","name"],"CreateEmbeddedObject",{R_:{measurement:"Scalar"}},1,0]],[]];
SPLM.MeasureBodies = class extends SPLM.GenericMeasure{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MeasureBodies";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MeasureBodies.ActiveValue = Object.freeze({
    "Volume" : "Volume", "Area" : "Area", "Mass" : "Mass", "RadiusOfGyration" : "RadiusOfGyration", "Weight" : "Weight", "Centroid" : "Centroid"});

SPLM.MeasureBodies.AnalysisUnit = Object.freeze({
    "PoundInch" : "PoundInch", "PoundFoot" : "PoundFoot", "GramMillimeter" : "GramMillimeter", "GramCentimeter" : "GramCentimeter", "KilogramMeter" : "KilogramMeter", "KilogramMillimeter" : "KilogramMillimeter", "CustomUnit" : "CustomUnit"});

export default SPLM;